<router-outlet />
<div [attr.id]="overlay"></div>
<div [attr.id]="appSpinner"></div>
<div [attr.id]="appToast"></div>
